import styled, { css } from 'styled-components';
import variables from '@styles/variables';
import { rem } from 'polished';
import Text from '@atoms/Text/Text';

// Shared styles for focus, hover, and selected states
const selectedStyles = css`
  // increase border and reduce margin to avoid flickering when selected or hovered
  // box-shadow, used in other places is covered StyledSlotDateName's background
  border-color: ${variables.colors.highlight};
  border-width: ${rem(2)};
  margin: ${rem(-1)};
`;

export const StyledSlotDate = styled.button<{ $selected: boolean }>`
  flex: 1;
  background-color: ${variables.colors.white};
  cursor: pointer;
  // Reset browser default button padding
  padding: 0;

  border: ${rem(1)} solid ${variables.colors.mediumGray};
  border-radius: ${rem(4)};

  &:hover {
    ${selectedStyles}
  }

  ${(props) => props.$selected && selectedStyles}
`;

export const StyledSlotDateName = styled(Text)<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: ${rem(25)};
  background: ${({ $selected: selected }) => (selected ? variables.colors.highlight : variables.colors.lightGray)};
  color: ${({ $selected: selected }) => (selected ? variables.colors.white : variables.colors.lighterBlack)};
`;
export const StyledSlotDateText = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: ${rem(36)};
`;
